import { motion } from "framer-motion";

export default function PriceStrip() {
  return (
    <section data-testid="price-strip" className="border-y border-[#D4AF37]/20 bg-[#0D0F12] py-14 sm:py-16">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-7xl mx-auto px-5 sm:px-8"
      >
        <h2 data-testid="price-strip-headline" className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight">
          <span className="text-[#F3F4F6]">Selected opportunities from </span>
          <span className="gold-text italic">₹40 Lacs*</span>
        </h2>
        <p className="mt-3 font-mono text-xs sm:text-sm uppercase tracking-[0.25em] text-[#9CA3AF]">
          Primary &amp; Resale <span className="text-[#D4AF37] mx-1">|</span> Ready-to-Move Opportunities
        </p>
        <p data-testid="selected-inventory-qualification" className="mt-5 max-w-2xl text-[11px] leading-relaxed text-[#6B7280]">
          *Indicative selected inventory, including resale opportunities, subject to availability and verification.
        </p>
      </motion.div>
    </section>
  );
}
